import httpManager from "@/app/shared/utils/httpManager";

export default async function (idPortfolio, payload) {
  let url = `/entities/portfolios/${idPortfolio}/typificactions/update-order/`;
  const response = await httpManager.put(url, payload);
  return response.data;
}
